import { BllOrtak } from './../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';



@Component({
  selector: 'page-dash-ana-sayfa',
  templateUrl: 'dash-ana-sayfa.html',
})
export class DashAnaSayfaPage {
  skip: number = 0;
  take: number = 50;
  Nakitkasa: number = 0;
  Poskasa: number = 0;
  OzetDurum: any = {};
  PosDurum: any = {};
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.nakitdurum();
    this.posdurum();
  }

  nakitdurum() {
    var formData = new FormData();
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "NakitDurum", "", false).then(a => {
      var sonuc = <any>a;
      this.OzetDurum = sonuc.SonucObject;
      this.Nakitkasa = 0;
      this.Poskasa = 0;
      this.OzetDurum.forEach(element => {
        this.Nakitkasa = parseFloat(element.Bakiye.toString());
      })
    })
  }
  posdurum() {
    var formData = new FormData();
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "PosDurum", "", false).then(a => {
      var sonuc = <any>a;
      this.PosDurum = sonuc.SonucObject;
      this.Poskasa = 0;
      this.PosDurum.forEach(element => {
        this.Poskasa = parseFloat(element.Bakiye.toString());
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/dash-ana-sayfa/dash-ana-sayfa.ts